// extracted by mini-css-extract-plugin
export var columnList = "_fy-0";